import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-confirm-overrride",
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
  templateUrl: "./confirm.component.html",
  styleUrls: ["./confirm.component.scss"],
})
export class ConfirmComponent {
  message = " ";
  title = "Alert";
  okAction = "ok";

  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public Data: any
  ) {
    this.message = Data.message;
    this.title = Data.title ?? this.title;
    this.okAction = Data.okAction ?? this.okAction;
  }

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
